var exports = {
  "kL": "GuildDiscoveryTab.module__container___WGM0dW",
  "wx": "GuildDiscoveryTab.module__header___WGM0dW",
  "DD": "GuildDiscoveryTab.module__title___WGM0dW",
  "VA": "GuildDiscoveryTab.module__subtitle___WGM0dW",
  "dc": "GuildDiscoveryTab.module__spinnerContainer___WGM0dW",
  "vz": "GuildDiscoveryTab.module__statusCard___WGM0dW",
  "jf": "GuildDiscoveryTab.module__statusRow___WGM0dW",
  "Rh": "GuildDiscoveryTab.module__statusLabel___WGM0dW",
  "Od": "GuildDiscoveryTab.module__statusBadge___WGM0dW",
  "Wp": "GuildDiscoveryTab.module__statusPending___WGM0dW",
  "Oe": "GuildDiscoveryTab.module__statusApproved___WGM0dW",
  "rP": "GuildDiscoveryTab.module__statusRejected___WGM0dW",
  "Zs": "GuildDiscoveryTab.module__statusRemoved___WGM0dW",
  "d2": "GuildDiscoveryTab.module__reviewReason___WGM0dW",
  "Zi": "GuildDiscoveryTab.module__formCard___WGM0dW",
  "bk": "GuildDiscoveryTab.module__fieldLabel___WGM0dW",
  "BK": "GuildDiscoveryTab.module__helpText___WGM0dW",
  "o1": "GuildDiscoveryTab.module__actions___WGM0dW",
  "$e": "GuildDiscoveryTab.module__warning___WGM0dW",
  "au": "GuildDiscoveryTab.module__warningContent___WGM0dW",
  "QW": "GuildDiscoveryTab.module__warningIcon___WGM0dW",
  "r2": "GuildDiscoveryTab.module__warningBody___WGM0dW",
  "tJ": "GuildDiscoveryTab.module__warningTitle___WGM0dW",
  "i4": "GuildDiscoveryTab.module__warningText___WGM0dW",
  "pq": "GuildDiscoveryTab.module__info___WGM0dW",
  "QI": "GuildDiscoveryTab.module__infoContent___WGM0dW",
  "G": "GuildDiscoveryTab.module__infoIcon___WGM0dW",
  "aV": "GuildDiscoveryTab.module__infoText___WGM0dW",
  "Uz": "GuildDiscoveryTab.module__tagsField___WGM0dW",
  "Cs": "GuildDiscoveryTab.module__tagsList___WGM0dW",
  "r3": "GuildDiscoveryTab.module__tagChip___WGM0dW",
  "Xp": "GuildDiscoveryTab.module__tagChipRemove___WGM0dW",
  "C_": "GuildDiscoveryTab.module__tagsInputRow___WGM0dW",
};

module.exports = exports;
